import React from "react";
import LogoBadge from "./SVGComponents/LogoBadge";
import { gsap } from "gsap";
import { ScrollTrigger, SplitText } from "gsap/all";
import { useGSAP } from "@gsap/react";
import LogoIcon from "./SVGComponents/LogoIcon";

// Register ScrollTrigger and SplitText plugins
gsap.registerPlugin(ScrollTrigger, SplitText);

const AboutRema = () => {
  const badgeRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const paragraph1Ref = React.useRef(null);

  // GSAP animations using useGSAP hook
  useGSAP(
    () => {
      // Badge rotation animation
      const spin = gsap.to(badgeRef.current, {
        rotation: 360,
        repeat: -1,
        ease: "linear",
        duration: 9,
        paused: false,
      });

      // Pause on hover
      const handleMouseEnter = () => spin.pause();
      const handleMouseLeave = () => spin.resume();

      if (badgeRef.current) {
        badgeRef.current.addEventListener("mouseenter", handleMouseEnter);
        badgeRef.current.addEventListener("mouseleave", handleMouseLeave);
      }

      // Cleanup function
      return () => {
        if (badgeRef.current) {
          badgeRef.current.removeEventListener("mouseenter", handleMouseEnter);
          badgeRef.current.removeEventListener("mouseleave", handleMouseLeave);
        }
        spin.kill();
      };
    },
    { scope: containerRef }
  );

  return (
    <section
      ref={containerRef}
      className="bg-[#F0F4E6] py-16 px-4 sm:px-6 lg:px-8"
    >
      <div className="container mx-auto px-10 md:py-[70px] lg:py-0">
        {/* Content Container */}
        <div className="flex flex-col lg:flex-row lg:justify-between items-center text-center lg:text-left space-y-8">
          {/* Description Text */}
          <div className="space-y-6 lg:max-w-4xl md:text-2xl lg:text-lg xl:text-2xl text-[#11302D]">
            <p
              ref={paragraph1Ref}
              className="leading-relaxed font-medium whitespace-pre-line"
            >
              REMA is a one-day, high-impact event bringing together the core
              players in Africa's real estate and PropTech ecosystem. From
              property developers to community executives, regulators to
              technology providers.
              <br />
              <br />
              REMA is the space to explore how innovation is transforming the
              way we build and manage communities across Africa.
            </p>
          </div>

          {/* REMA Conference Badge */}
          <div className="mt-8 w-full flex justify-center relative">
            <div className="absolute h-24 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ">
              <LogoIcon />
            </div>
            <div ref={badgeRef}>
              <LogoBadge />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutRema;
